import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useSearch } from '../contexts/SearchContext';
import { NAV_PATHS } from '../constants/navigation';
import { SECTION_NAV_ITEMS } from '../config/navItems';

type SectionNavLinksProps = {
  className?: string;
  linkClassName?: string;
  showLabels?: boolean;
  iconSize?: number;
};

const SectionNavLinks: React.FC<SectionNavLinksProps> = ({
  className = 'nav-links',
  linkClassName = 'nav-link',
  showLabels = true,
  iconSize = 18,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { clearSearch } = useSearch();

  const handleNavClick = () => {
    clearSearch();
  };

  const handleGrammarClick = (e: React.MouseEvent) => {
    if (location.pathname === NAV_PATHS.GRAMMAR) {
      e.preventDefault();
      navigate(NAV_PATHS.GRAMMAR, {
        replace: true,
        state: { reset: Date.now() },
      });
    }
    handleNavClick();
  };

  return (
    <div className={className}>
      {SECTION_NAV_ITEMS.map((item) => {
        const IconComponent = item.icon;
        const isActive =
          location.pathname === item.path ||
          location.pathname.startsWith(`${item.path}/`);

        return (
          <Link
            key={item.path}
            to={item.path}
            className={`${linkClassName} ${isActive ? 'active' : ''}`}
            aria-label={item.label}
            aria-current={isActive ? 'page' : undefined}
            onClick={
              item.path === NAV_PATHS.GRAMMAR ? handleGrammarClick : handleNavClick
            }
          >
            <IconComponent size={iconSize} className="nav-link-icon" aria-hidden />
            {showLabels && (
              <span className="nav-link-label">{item.label}</span>
            )}
          </Link>
        );
      })}
    </div>
  );
};

export default SectionNavLinks;
